import React from "react"
import { Link } from "gatsby"
import { useLanguage } from "gatsby-singita-theme/src/context/LanguageContext"

export function LocaleLink({ to, ...props }) {
  const lang = useLanguage()
  const ref = lang === "en-US" ? to : `/${lang}${to}`
  return <Link to={ref} {...props} />
}
